export interface Zone {
  min: number
  max: number
  label: string
  color: string
  bg: string
  desc: string
}

export const zones: Zone[] = [
  {
    min: 0,
    max: 3,
    label: 'ZONA ROJA — SIN SISTEMA',
    color: 'var(--red)',
    bg: 'rgba(192,57,43,0.15)',
    desc: 'Tu agencia opera sin estructura de reclutamiento ni activación. Cada recluta que entra depende de tu esfuerzo personal para sobrevivir. El problema no es falta de ganas — es falta de arquitectura.',
  },
  {
    min: 4,
    max: 6,
    label: 'ZONA NARANJA — SISTEMA PARCIAL',
    color: 'var(--orange)',
    bg: 'rgba(230,126,34,0.15)',
    desc: 'Tienes piezas sueltas pero no un sistema conectado. Algunas cosas funcionan, otras son improvisación. Los resultados no son predecibles ni duplicables. Necesitas estructura completa, no parches.',
  },
  {
    min: 7,
    max: 8,
    label: 'ZONA AMARILLA — EN CAMINO',
    color: 'var(--gold)',
    bg: 'rgba(212,168,67,0.15)',
    desc: 'Tu agencia tiene estructura en varias áreas pero le faltan componentes críticos para escalar. Puedes reclutar y activar, pero no duplicar. Estás cerca — el siguiente paso es cerrar las brechas.',
  },
  {
    min: 9,
    max: 10,
    label: 'ZONA VERDE — SISTEMA COMPLETO',
    color: 'var(--green)',
    bg: 'rgba(39,174,96,0.15)',
    desc: 'Tu agencia opera con sistema propio, documentado y duplicable. Si tienes 9-10 de estos elementos, estás en el 5% superior. La pregunta ahora es cómo lo escalas más rápido.',
  },
]
